export const getCouponOfferContentStyles = () => ({
  offerContainer: {
    paddingTop: 8,
    paddingBottom: 16,
  },
  couponDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  percentCouponIcon: {
    fontSize: 32,
    marginRight: 24,
    lineHeight: 'initial',
  },
  couponIcon: {
    'font-size': '32px !important',
    'line-height': '0.5 !important',
    'margin-right': '21px !important',
  },
  myCurrentOffer: {
    display: 'flex',
    fontSize: 14,
    flexDirection: 'column',
    maxWidth: '350px',
  },
  OfferHelpLink: {
    height: 20,
    fontSize: 14,
    paddingTop: 3,
    marginBottom: 8,
    textDecoration: 'underline',
  },
  offerDetailsTag: {
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: 14,
    marginBottom: 0,
  },
  offerStatusRow: {
    marginBottom: 0,
    marginTop: 16,
    height: 23,
  },
  offerDetailsRow: {
    marginTop: 8,
  },
  columnFont: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
  },
  valueFont: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
  },
  addPromotionalCodeButton: {
    backgroundColor: '#FFFFFF',
    color: '#323130',
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    marginTop: 30,
    marginRight: 8,
    display: 'inline-block',
  },
});
